import { render, staticRenderFns } from "./systemIdentify.vue?vue&type=template&id=48b34afc&scoped=true&"
import script from "./systemIdentify.vue?vue&type=script&lang=js&"
export * from "./systemIdentify.vue?vue&type=script&lang=js&"
import style0 from "./systemIdentify.vue?vue&type=style&index=0&id=48b34afc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b34afc",
  null
  
)

export default component.exports